import extractColors from "utils/extractColors";
function addAlpha(hex, alpha) {
  const { r, g, b } = extractColors(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
export default addAlpha;
